import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=499816a1&"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js&"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports